class VaccineController {
  constructor() {
    this.name = 'vaccine';
  }
}

export default VaccineController;



// WEBPACK FOOTER //
// ./client/app/components/vaccine/vaccine.controller.js